export const OPTIONS_MIN_WIDTH = "500px";
export const OPTIONS_MAX_HEIGHT = 500;

export const SLOT_PROPS = {
  listbox: { sx: { maxHeight: OPTIONS_MAX_HEIGHT } },
  paper: {
    sx: {
      width: "max-content",
      minWidth: `max(100%, ${OPTIONS_MIN_WIDTH})`,
    },
  },
};
